/*                                                                                                                                                 */
import $protobuf from "protobufjs/minimal.js";

/*             */
const $Writer = $protobuf.Writer, $util = $protobuf.util;

/*                      */
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const History = $root.History = (() => {

    /**
 *
 *
 *
 *
 *
 */

    /**
 *
 *
 *
 *
 *
 *
 */
    function History(p) {
        this.historyItems = [];
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }

    /**
 *
 *
 *
 *
 */
    History.prototype.historyItems = $util.emptyArray;

    /**
 *
 *
 *
 *
 */
    History.prototype.currentTimestamp = null;

    /*                                                     */
    let $oneOfFields;

    /**
 *
 *
 *
 *
 */
    Object.defineProperty(History.prototype, "_currentTimestamp", {
        get: $util.oneOfGetter($oneOfFields = ["currentTimestamp"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
 *
 *
 *
 *
 *
 *
 */
    History.create = function create(properties) {
        return new History(properties);
    };

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    History.encode = function encode(m, w) {
        if (!w)
            w = $Writer.create();
        if (m.historyItems != null && m.historyItems.length) {
            for (var i = 0; i < m.historyItems.length; ++i)
                $root.HistoryItem.encode(m.historyItems[i], w.uint32(10).fork()).ldelim();
        }
        if (m.currentTimestamp != null && Object.hasOwnProperty.call(m, "currentTimestamp"))
            w.uint32(16).uint64(m.currentTimestamp);
        return w;
    };

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    History.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    return History;
})();

export const HistoryItem = $root.HistoryItem = (() => {

    /**
 *
 *
 *
 *
 *
 */

    /**
 *
 *
 *
 *
 *
 *
 */
    function HistoryItem(p) {
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }

    /**
 *
 *
 *
 *
 */
    HistoryItem.prototype.term = "";

    /**
 *
 *
 *
 *
 */
    HistoryItem.prototype.date = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
 *
 *
 *
 *
 *
 *
 */
    HistoryItem.create = function create(properties) {
        return new HistoryItem(properties);
    };

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    HistoryItem.encode = function encode(m, w) {
        if (!w)
            w = $Writer.create();
        if (m.term != null && Object.hasOwnProperty.call(m, "term"))
            w.uint32(10).string(m.term);
        if (m.date != null && Object.hasOwnProperty.call(m, "date"))
            w.uint32(16).uint64(m.date);
        return w;
    };

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    HistoryItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    return HistoryItem;
})();

export default $root;